import React from 'react'

import {
  func, string, bool, array, object, number, oneOfType,
} from 'prop-types'

import { EMPTY_ARRAY, EMPTY_OBJECT } from 'Utils/stableDefaults'
import useBreakpoint from 'Utils/useBreakpoint'

import ModelInfoFooter from './ModelInfoFooter'
import ModelInfoSidebar from './ModelInfoSidebar'

function ModelInfo({
  onAddToWishlist = null,
  onRemoveFromWishlist = null,
  isOnWishlist,
  currentSelectedFileTypes,
  setSelectedFilters,
  trackFilterChange,
  tags = EMPTY_ARRAY,
  types = EMPTY_OBJECT,
  polygons,
  vertices,
  onAddToCart = null,
  onRemoveFromCart,
  isOnCart,
  textures = false,
  materials = false,
  uvwMapping = false,
  pluginsUsed = false,
  cgtVerification = EMPTY_OBJECT,
  fullScreenGallery = false,
  hideInfo,
  isPurchased = false,
  isCgtStandardThresholdReached = false,
  showCgtVerification,
  itemAttributes,
  ...rest
}) {
  const activeBreakpoint = useBreakpoint()
  const renderFooter = ['xs', 'sm', 'md'].includes(activeBreakpoint) || fullScreenGallery

  const handleWishlist = isOnWishlist
    ? () => onRemoveFromWishlist()
    : () => onAddToWishlist()

  const handleCart = isOnCart
    ? () => onRemoveFromCart()
    : () => onAddToCart()

  const isWishlistAvailable = !!onRemoveFromWishlist && !!onAddToWishlist
  const isCartAvailable = !!onRemoveFromCart && !!onAddToCart

  if (renderFooter) {
    return (
      <ModelInfoFooter
        {...rest}
        handleWishlist={handleWishlist}
        isOnWishlist={isOnWishlist}
        isWishlistAvailable={isWishlistAvailable}
        handleCart={handleCart}
        isOnCart={isOnCart}
        isCartAvailable={isCartAvailable}
        fullScreenGallery={fullScreenGallery}
        hideInfo={hideInfo}
        isPurchased={isPurchased}
        itemAttributes={itemAttributes}
      />
    )
  }

  return (
    <ModelInfoSidebar
      {...rest}
      currentSelectedFileTypes={currentSelectedFileTypes}
      handleWishlist={handleWishlist}
      isOnWishlist={isOnWishlist}
      isWishlistAvailable={isWishlistAvailable}
      setSelectedFilters={setSelectedFilters}
      trackFilterChange={trackFilterChange}
      tags={tags}
      types={types}
      polygons={polygons}
      vertices={vertices}
      handleCart={handleCart}
      isOnCart={isOnCart}
      isCartAvailable={isCartAvailable}
      textures={textures}
      materials={materials}
      uvwMapping={uvwMapping}
      pluginsUsed={pluginsUsed}
      cgtVerification={cgtVerification}
      isPurchased={isPurchased}
      isCgtStandardThresholdReached={isCgtStandardThresholdReached}
      showCgtVerification={showCgtVerification}
      itemAttributes={itemAttributes}
    />
  )
}

ModelInfo.propTypes = {
  onAddToCart: func,
  userPicture: string,
  onAddToWishlist: func,
  onRemoveFromWishlist: func,
  isOnWishlist: bool.isRequired,
  fullScreenGallery: bool,
  tags: array,
  currentSelectedFileTypes: array.isRequired,
  setSelectedFilters: func.isRequired,
  trackFilterChange: func.isRequired,
  types: object,
  polygons: oneOfType([number, string, bool]),
  vertices: oneOfType([number, string, bool]),
  isOnCart: bool.isRequired,
  onRemoveFromCart: func.isRequired,
  textures: bool,
  materials: bool,
  uvwMapping: bool,
  pluginsUsed: bool,
  cgtVerification: object,
  hideInfo: bool.isRequired,
  isPurchased: bool,
  isCgtStandardThresholdReached: bool,
  showCgtVerification: bool.isRequired,
  itemAttributes: object.isRequired,
}

export default ModelInfo
